/*
 * general-note (zod)
 */
import { createInsertSchema, createSelectSchema } from "drizzle-zod"
import * as z from "zod"
import { globalCreateExclude, globalUpdateExclude } from "../utils/constants"
import { generalNotes } from "./general-note.schema"

/* Select */
export type GeneralNote = z.infer<typeof selectGeneralNoteSchema>
export const selectGeneralNoteSchema = createSelectSchema(generalNotes)

/* Filters */
export type GeneralNoteFilters = z.infer<typeof generalNoteFiltersSchema>
export const generalNoteFiltersSchema = z.object({
	id: z.string().optional(),
	patientId: z.string().optional(),
	generalNoteType: z.number().optional(),
	importanceType: z.number().optional(),
	noteSeen: z.boolean().optional(),
	active: z.boolean().optional(),
})

/* Create */
export const createGeneralNoteSchema = createInsertSchema(generalNotes, {
	note: z.string().min(1, "Note is required"),
	generalNoteType: z.number().int().min(0).max(1).default(0),
	importanceType: z.number().int().min(0).max(3).default(0),
}).partial(globalCreateExclude)
export type CreateGeneralNote = z.infer<typeof createGeneralNoteSchema>

/* Update */
export const updateGeneralNoteSchema = createInsertSchema(generalNotes)
	.omit(globalUpdateExclude)
	.partial()
	.required({ id: true })
export type UpdateGeneralNote = z.infer<typeof updateGeneralNoteSchema>
